import { CompanySelectionService } from '@App/app/shared/services/company-selection/company-selection.service';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCompanySelectionDirective } from '../shared/base-company-selection.component';

@Component({
  selector: 'app-company-selection',
  templateUrl: './company-selection.component.html',
  styleUrls: ['./company-selection.component.scss'],
})
export class CompanySelectionComponent extends BaseCompanySelectionDirective {
  constructor(route: ActivatedRoute, companySelectionService: CompanySelectionService) {
    super(route, companySelectionService);
  }
}
